/*
 * YAMU CRO: Foxkit upsell popup + cart drawer fix.
 *
 * Issue (live, before this patch):
 *  - After Add-to-Cart, Foxkit's upsell popup shows.
 *  - If the user closes/rejects the popup, the cart drawer either does not
 *    open OR opens after a 5 to 6 second delay.
 *  - The popup has no explicit "Decline" CTA, only a close X.
 *
 * Fix (this file):
 *  1. Watch for Foxkit's popup mounting and inject a clear "No thanks,
 *     continue to cart" decline button.
 *  2. When Foxkit's popup closes for ANY reason (accept, decline, X, esc,
 *     outside click), make sure the cart drawer is open.
 *  3. Safety net: if 1500ms after Add-to-Cart the cart drawer is still
 *     closed and no Foxkit popup is showing, force-open the cart drawer.
 *
 * Loaded from layout/theme.liquid as a deferred script.
 */

(function () {
  'use strict';

  // Foxkit's app injects its DOM with id/class patterns that include "foxkit".
  // We match the popup family defensively because Foxkit may rename internals.
  var FOXKIT_POPUP_SELECTORS = [
    '[id*="foxkit" i][class*="upsell" i]',
    '[id*="foxkit" i][class*="popup" i]',
    '[id*="foxkit" i][class*="modal" i]',
    '[class*="foxkit-upsell" i]',
    '[class*="foxkit-popup" i]',
    '[class*="foxkit-modal" i]',
    'foxkit-upsell-popup',
    'foxkit-popup',
    '.fk-upsell-popup',
    '.fk-popup',
  ].join(',');

  var DECLINE_BUTTON_ID = 'yamu-foxkit-decline-btn';
  var DECLINE_BUTTON_LABEL = 'No thanks, continue to cart';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    if (typeof drawer.show === 'function' && !drawer.hasAttribute('open')) {
      try {
        drawer.show();
      } catch (e) {
        drawer.setAttribute('open', '');
      }
    }
  }

  function isElementVisible(el) {
    if (!el || !el.isConnected) return false;
    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    var styles = window.getComputedStyle(el);
    return styles.visibility !== 'hidden' && styles.display !== 'none' && styles.opacity !== '0';
  }

  function findVisibleFoxkitPopup() {
    var nodes = document.querySelectorAll(FOXKIT_POPUP_SELECTORS);
    for (var i = 0; i < nodes.length; i += 1) {
      if (isElementVisible(nodes[i])) return nodes[i];
    }
    return null;
  }

  function injectDeclineButton(popup) {
    if (!popup || popup.querySelector('#' + DECLINE_BUTTON_ID)) return;

    var btn = document.createElement('button');
    btn.id = DECLINE_BUTTON_ID;
    btn.type = 'button';
    btn.textContent = DECLINE_BUTTON_LABEL;
    btn.style.cssText = [
      'display: block',
      'width: 100%',
      'margin-top: 14px',
      'padding: 14px 20px',
      'background: transparent',
      'color: currentColor',
      'border: 1px solid currentColor',
      'border-radius: 999px',
      'font-family: inherit',
      'font-size: 13px',
      'font-weight: 600',
      'letter-spacing: 0.04em',
      'cursor: pointer',
      'opacity: 0.8',
      'transition: opacity 0.15s ease, background 0.15s ease',
    ].join(';');

    btn.addEventListener('mouseenter', function () {
      btn.style.opacity = '1';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.opacity = '0.8';
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Try to use Foxkit's own close mechanism first
      var closeBtn = popup.querySelector(
        '[class*="close" i], [aria-label*="close" i], [data-action="close"], button.foxkit-close'
      );
      if (closeBtn) {
        closeBtn.click();
      } else {
        popup.style.display = 'none';
        popup.setAttribute('hidden', '');
      }
      // Open cart drawer next tick so any popup-close handlers run first
      setTimeout(openCartDrawer, 50);
    });

    // Try to drop the button into a likely "actions" container, else just append
    var actions = popup.querySelector(
      '[class*="action" i], [class*="footer" i], [class*="cta" i], form'
    );
    (actions || popup).appendChild(btn);
  }

  // Watches a popup element and fires callback when it leaves the DOM or becomes hidden.
  function watchPopupClose(popup, callback) {
    var fired = false;
    function done() {
      if (fired) return;
      fired = true;
      observer.disconnect();
      clearInterval(visibilityCheck);
      callback();
    }

    var observer = new MutationObserver(function () {
      if (!popup.isConnected || !isElementVisible(popup)) {
        done();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });

    // Backup visibility poll in case the mutation doesn't bubble
    var visibilityCheck = setInterval(function () {
      if (!popup.isConnected || !isElementVisible(popup)) done();
    }, 250);

    // Hard timeout: if popup is somehow still around at 12s, give up watching and just open drawer.
    setTimeout(done, 12000);
  }

  function handleProductAdded() {
    // Give Foxkit a brief moment to mount its popup.
    setTimeout(function () {
      var popup = findVisibleFoxkitPopup();

      if (popup) {
        injectDeclineButton(popup);
        watchPopupClose(popup, openCartDrawer);
      } else {
        // No popup mounted, ensure cart drawer is open.
        openCartDrawer();
      }

      // Final safety net: at 2500ms total, if no drawer + no popup, open it.
      setTimeout(function () {
        var drawer = getCartDrawer();
        if (!drawer || drawer.hasAttribute('open')) return;
        if (!findVisibleFoxkitPopup()) openCartDrawer();
      }, 2400);
    }, 100);
  }

  document.addEventListener('product-ajax:added', handleProductAdded);

  // Foxkit may also re-mount the popup after a brief delay even if cart drawer
  // opens first (this is what gives the 5-6 second feel). If a popup appears
  // AFTER drawer is open, inject the decline button into it as well.
  var rootObserver = new MutationObserver(function () {
    var popup = findVisibleFoxkitPopup();
    if (popup && !popup.querySelector('#' + DECLINE_BUTTON_ID)) {
      injectDeclineButton(popup);
    }
  });
  rootObserver.observe(document.body, { childList: true, subtree: true });
})();
